import commission from './commission'

export default [
  ...commission,
]
